import React from 'react'

import { useLocation } from 'react-router-dom'

import { StackProps, YStack } from 'tamagui'
import { H2, H3, Text, Paragraph, Strong } from '../Text'
import { Link } from '../Link'
import { Card } from '../Card'

export const NoEventsPlaceholder = (props: StackProps) => {
  const location = useLocation()

  return (
    <YStack {...props} padding='$8' gap='$4' alignItems='center' data-nosnippet>
      <H3 textAlign='center'>🔍 Looks like you got to the bottom!</H3>

      <Paragraph textAlign='center'>
        Couldn't find what you're looking for?
      </Paragraph>

      <Paragraph textAlign='center'>
        <Link
          href='/events/new'
          options={{
            state: {
              backgroundLocation:
                location.state?.backgroundLocation || location,
            },
          }}
        >
          Host an event
        </Link>{' '}
        to share your passion! 💖
      </Paragraph>
    </YStack>
  )
}

export default NoEventsPlaceholder
